<template>
  <div class="nav-com disFlex Flex-center Flex-around" v-if="Show">
    <div
      class="nav-item disFlex vertical fvc"
      @click="linkto(item.url)"
      :class="(Path==`${item.url}`)?'activeblack':''"
      v-for="item in navList"
      :key="item.id"
    >
      <img :src="item.logo" class="home" v-if="Path==`${item.url}`" />
      <img :src="item.defaultLogo" class="home" v-else />
      {{item.name}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [],
      sColor: localStorage.getItem("stylecolor"),
      styleColor: true,
    };
  },
  created() {
    this.getConfig();
    // this.getActInfo();
  },
  computed: {
    Path: function () {
      // if (
      //   this.$route.path == "/prehhh" ||
      //   this.$route.path == "/prrheat" ||
      //   this.$route.path == "/prehead" ||
      //   this.$route.path == "/prehttt"
      // ) {
      //   return "/preheat";
      // }
      return this.$route.path;
    },
    Show: function () {
      return this.$route.meta.showBottom;
    },
  },
  methods: {
    getActInfo() {
      this.$http.post("/v1/home/activity").then((res) => {
        if (res.code === 0) {
          this.styleColor = res.data.style == "red" ? true : false;
        }
      });
    },
    getConfig() {
      this.$http.post("/v1/home/navi_bar").then((res) => {
        this.navList = res.data;
        // if (this.$route.query.act_id) {
        //   this.getActInfo();
        // }
      });
    },
    linkto(e) {
      let userType = localStorage.getItem("userType");
      if(e === "/spokesman"){
        e = "/spokesmannew"
      }
      if (
        (userType === "act" || userType === "brand" || userType === "staff") &&
        ([this.$utils.getMyPagePath()].includes(e))
      ) {
        e = "/kpi";
      }
      if (
        (userType === "act" || userType === "brand" || userType === "staff") &&
        e === "/spokesmannew"
      ) {
        e = "/kpi";
      }
      console.log(e);
      console.log("href", location.href);
      console.log("actid", this.$route.query.act_id);
      this.$router.push({
        path: e,
        // 此处底部导航跳转不可使用缓存，因为IOS的浮窗并不是重新加载当前的路径，而是直接唤起原页面，URL中仍是初始进入的地址，
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.nav-com {
  z-index: 500;
  position: fixed;
  left: 0;
  bottom: 0;
  padding-top: 6px;
  width: 100%;
  height: 55px;
  background: rgba(255, 255, 255, 1);
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #919191;
  line-height: 17px;
  .home {
    width: 24px;
    height: 24px;
  }
}
.activeblue {
  color: #003078 !important;
}
.activeblack {
  color: black !important;
}
.activered {
  color: #b80000 !important;
}
</style>